import App from "../app";
import { FlagEvent } from "../events";
import { AttemptId, ItemId, ProductId, QuizId } from "../model/datasource";
import { ContentItem } from "../model/datasource/item";
import { ListItem } from "../model/datasource/list";
import Controller from "./controller";
import { Annotations } from "../lib/userdata";
import Model from "../model/model";

export class FlagController<P extends ProductId, A extends AttemptId, Z extends QuizId, I extends ItemId> extends Controller<P, A, Z, I> {
	bind(target: EventTarget, app: App<P, A, Z, I>): void {
		target.addEventListener(FlagEvent.type, (e: FlagEvent) => this.flag(app, e.detail));
	}

	flag(app: App<P, A, Z, I>, flagged: boolean): void {
		const current: number = app.current.get();
		let item: I | undefined;
		Promise.all([
			app.model.metadata.getProductId(),
			app.model.metadata.getAttempt(),
			app.content.get(current).catch(() => undefined),
			app.content.meta(current),
		]).then((
			[product, attempt, content, meta]:
			[product: P, attempt: A, content: ContentItem<I> | undefined, meta: ListItem<I>]
		) => {
			item = content?.id ?? meta.id;
			app.view.list.displayFlagged(item, flagged, "loading");
			const userdata = app.userdata.set(current, item, { flagged });
			return Model.retryPromise(() =>
				app.model.item.setUserData(product, attempt, item, userdata)
			).then(() => ({ item, flagged, userdata }));
		}).then(({item, flagged, userdata}: {item: I, flagged: boolean, userdata: Annotations}) => {
			app.model.list.setAttributes(item, userdata);
			if (app.current.get() === current) {
				app.view.header.displayFlag(flagged);
			}
			app.view.list.displayFlagged(item, flagged);
		}).catch(err => {
			if (item) { app.view.list.displayFlagged(item, flagged, "error"); }
		});
	}
}